import { useMemo } from 'react';

import {
  useAreAMACoorganizersEnabled,
  useIsAMACreationV2Enabled,
  useIsAMAPrivateEnabled,
  useIsCalendarInvitationEnabled,
  useIsNewQuestionNotificationEnabled,
  useIsQuestionsOnlyMode,
} from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventCreationPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventCreationPage'> = (
  options
) => {
  const askMeAnythingEventCreationPageOverrides = options?.overrides?.askMeAnythingEventCreationPage;

  const isAMACreationV2Enabled = useIsAMACreationV2Enabled();
  const areAMACoorganizersEnabled = useAreAMACoorganizersEnabled();
  const isAMAPrivateEnabled = useIsAMAPrivateEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isNewQuestionNotificationEnabled = useIsNewQuestionNotificationEnabled();
  const isCalendarInvitationEnabled = useIsCalendarInvitationEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        coorganizers: false,
        private: false,
        newQuestionNotification: isNewQuestionNotificationEnabled,
        calendarInvitationToggleEnabled: isCalendarInvitationEnabled,
        ...askMeAnythingEventCreationPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMACreationV2Enabled,
      coorganizers: areAMACoorganizersEnabled,
      private: isAMAPrivateEnabled,
      newQuestionNotification: isNewQuestionNotificationEnabled,
      calendarInvitationToggleEnabled: isCalendarInvitationEnabled,
      ...askMeAnythingEventCreationPageOverrides,
    };
  }, [
    areAMACoorganizersEnabled,
    askMeAnythingEventCreationPageOverrides,
    isAMACreationV2Enabled,
    isAMAPrivateEnabled,
    isNewQuestionNotificationEnabled,
    isCalendarInvitationEnabled,
    isQuestionsOnlyMode,
  ]);
};
